export default __webpack_public_path__ + "static/2-628eb922b4717714f1aeabae7935bfa5.webp";